import { type FC } from "react";
import { GuidanceBox } from "@root/shared/components/GuidanceBox";
import { Icon } from "@root/shared/components/Icon";
import { TextLink } from "@root/shared/components/TextLink";
import { colors } from "@root/shared/styles/sprinkles.css";
import * as styles from "./styles.css";

type ReopenAlertType = "invalid_on_hold" | "invalid_nearfuture" | "invalid";

type Props = {
  reopenAlertType: ReopenAlertType | null;
  manualUrl: string;
  isSp: boolean;
};

const REOPEN_ALERT_TYPES: ReopenAlertType[] = ["invalid_on_hold", "invalid_nearfuture", "invalid"];

export const GuidanceBoxForInquiry: FC<Props> = ({ reopenAlertType, manualUrl, isSp }) => {
  const isReopenAlert = reopenAlertType !== null && REOPEN_ALERT_TYPES.includes(reopenAlertType);
  const guidanceBoxTheme = isReopenAlert ? "red" : "pink";
  const normalMsg = (
    <p className={styles.infoText}>
      <span className={styles.iconBox}>
        <Icon name="information" color={colors.Biyo} />
      </span>
      お問い合わせ前に、
      {isSp && <br />}
      <TextLink
        icon={<Icon name="target-blank" />}
        href={manualUrl}
        target="_blank"
        className={styles.textLink}
      >
        マニュアル・よくあるご質問
      </TextLink>
      {isSp && <br />}
      をご確認ください。
    </p>
  );
  const reopenMsg = (
    <>
      <p className={styles.alertText}>
        <span className={styles.iconBox}>
          <Icon name="attention" />
        </span>
        ご確認ください
      </p>
      <p className={styles.alertTextDetail}>
        {reopenAlertType === "invalid_on_hold" && (
          <>
            ご利用の休止に際して確認事項がございます。下記お問い合わせフォームよりご連絡ください。
            <br />
            こちらのフォームでは、休止の申請は完了しません。ご注意ください。
          </>
        )}
        {reopenAlertType === "invalid_nearfuture" && (
          <>
            ご利用の再開に際して確認事項がございます。下記お問い合わせフォームよりご連絡ください。
            <br />
            こちらのフォームでは、再開の申請は完了しません。ご注意ください。
          </>
        )}
        {reopenAlertType === "invalid" && (
          <>
            ご利用の再開に際して事前に確認事項がございます。下記お問い合わせフォームよりご連絡ください。
            <br />
            こちらのフォームでは、休止期間・プラン・店舗数の変更手続きは完了しません。ご注意ください。
          </>
        )}
      </p>
    </>
  );

  return (
    <GuidanceBox themeColor={guidanceBoxTheme} className={styles.box}>
      {isReopenAlert ? reopenMsg : normalMsg}
    </GuidanceBox>
  );
};
